import type {
  CreateProcessoPermissaoDto,
  UpdateProcessoPermissaoDto,
} from '@/types/processo/processoPermissaoTypes';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { processoPermissoesService } from './services';

export const buscarUsuarios = createAsyncThunk(
  'processoPermissoes/buscarUsuarios',
  async ({ email, nome }: { email?: string; nome?: string }, { rejectWithValue }) => {
    try {
      return await processoPermissoesService.buscarUsuarios(email, nome);
    } catch (error) {
      return rejectWithValue(error instanceof Error ? error.message : 'Erro ao buscar usuários');
    }
  },
);

export const listarPermissoes = createAsyncThunk(
  'processoPermissoes/listar',
  async (processoId: string, { rejectWithValue }) => {
    try {
      return await processoPermissoesService.listar(processoId);
    } catch (error) {
      return rejectWithValue(error instanceof Error ? error.message : 'Erro ao listar permissões');
    }
  },
);

export const criarPermissao = createAsyncThunk(
  'processoPermissoes/criar',
  async (
    { processoId, data }: { processoId: string; data: CreateProcessoPermissaoDto },
    { rejectWithValue },
  ) => {
    try {
      return await processoPermissoesService.criar(processoId, data);
    } catch (error) {
      return rejectWithValue(error instanceof Error ? error.message : 'Erro ao criar permissão');
    }
  },
);

export const atualizarPermissao = createAsyncThunk(
  'processoPermissoes/atualizar',
  async (
    {
      processoId,
      usuarioId,
      data,
    }: {
      processoId: string;
      usuarioId: string;
      data: UpdateProcessoPermissaoDto;
    },
    { rejectWithValue },
  ) => {
    try {
      return await processoPermissoesService.atualizar(processoId, usuarioId, data);
    } catch (error) {
      return rejectWithValue(
        error instanceof Error ? error.message : 'Erro ao atualizar permissão',
      );
    }
  },
);

export const removerPermissao = createAsyncThunk(
  'processoPermissoes/remover',
  async (
    { processoId, usuarioId }: { processoId: string; usuarioId: string },
    { rejectWithValue },
  ) => {
    try {
      await processoPermissoesService.remover(processoId, usuarioId);
      return { processoId, usuarioId };
    } catch (error) {
      return rejectWithValue(error instanceof Error ? error.message : 'Erro ao remover permissão');
    }
  },
);

export const verificarAcesso = createAsyncThunk(
  'processoPermissoes/verificarAcesso',
  async (processoId: string, { rejectWithValue }) => {
    try {
      return await processoPermissoesService.verificarAcesso(processoId);
    } catch (error) {
      return rejectWithValue(error instanceof Error ? error.message : 'Erro ao verificar acesso');
    }
  },
);
